import {
  HStack,
  NumberInput,
  NumberInputField,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import * as PropTypes from 'prop-types';

/**
 *
 * @param {any}input
 * @param {function}handleChangeInput
 * @return {JSX.Element}
 * @constructor
 */
export const UsingShopifyPayment = ({ input, handleChangeInput }) => {
  return (
    <HStack spacing={8} justify={'start'}>
      <Text fontSize={'md'} pl={6}>
        Using shopify payment ?
      </Text>
      <RadioGroup
        onChange={val => handleChangeInput('typePaymentGateway', val)}
        value={input.typePaymentGateway}
      >
        <Stack direction="row">
          <Radio size="md" value="shopify">
            Yes, I do
          </Radio>
          <Radio size="md" value="anathorPayment">
            No, I don’t
          </Radio>
        </Stack>
      </RadioGroup>
      <HStack justify={'right'} pl={24}>
        <Text
          fontSize={'md'}
          color={input.typePaymentGateway === 'shopify' ? 'gray' : ''}
          onChange={val => handleChangeInput('avgOrderValue', val)}
        >
          External payment gateway fees{' '}
        </Text>
        <HStack>
          <NumberInput
            value={input.externalPaymentPercent}
            width={20}
            min={0}
            max={100}
            keepWithinRange={false}
            clampValueOnBlur={false}
            isDisabled={input.typePaymentGateway === 'shopify'}
            onChange={val => handleChangeInput('externalPaymentPercent', val)}
          >
            <NumberInputField prefix={'%'} />
          </NumberInput>
          <Text color={input.typePaymentGateway === 'shopify' ? 'gray' : ''}>
            %
          </Text>
          <Text color={input.typePaymentGateway === 'shopify' ? 'gray' : ''}>
            +
          </Text>
          <NumberInput
            value={input.externalPaymentMoney}
            width={20}
            min={0}
            keepWithinRange={false}
            clampValueOnBlur={false}
            isDisabled={input.typePaymentGateway === 'shopify'}
            onChange={val => handleChangeInput('externalPaymentMoney', val)}
          >
            <NumberInputField />
          </NumberInput>
          <Text color={input.typePaymentGateway === 'shopify' ? 'gray' : ''}>
            $
          </Text>
        </HStack>
      </HStack>
    </HStack>
  );
};

UsingShopifyPayment.propTypes = {
  input: PropTypes.shape({
    orderPerMonth: PropTypes.number,
    typePaymentGateway: PropTypes.string,
    isPlanYearly: PropTypes.bool,
    avgOrderValue: PropTypes.number,
    externalPaymentPercent: PropTypes.number,
    externalPaymentMoney: PropTypes.number,
  }),
  handleChangeInput: PropTypes.func,
};
